export class TraspasoBienMueble {
  coleccionistaUuid: string
  bienCulturalUuid: string
  gestionesUuid: string[]
  cambioNoRegistro:boolean
}
